import { mapState } from 'vuex';
import CONST from '@/utils/Constants'
import eventBus from '@/config/EventBus';
import QRCode from 'qrcode'
import LayoutGreenScreen from "@/layouts/green-screen/layout-green-screen.vue"
import oButton from "@/objects/o-button/o-button.vue"
import oBlock from "@/objects/o-block/o-block.vue"
import oIconQrCode from "@/objects/o-icon/qr-code.vue"
import oIconSms from "@/objects/o-icon/sms.vue"
import oIconEmail from "@/objects/o-icon/email.vue"

export default {
  name: "vShare",
  components: {
    "layout-green-screen": LayoutGreenScreen,
    "o-button": oButton,
    "o-block": oBlock,
    "o-icon-qr-code": oIconQrCode,
    "o-icon-sms": oIconSms,
    "o-icon-email": oIconEmail
  },
  data() {
    return {
      qr_code: null
    }
  },
  methods: {
    stop() {
      eventBus.$emit(CONST.EVENT.INVENTION.STOPPED);
    },
    setQrCode() {
      const _this = this;

      QRCode.toDataURL(process.env.VUE_APP_SOUVENIR_URL + this.$store.state.invention_id)
      .then(url => {
        _this.qr_code = url;
      })
      .catch(err => {
        throw err;
      })
    }
  },
  computed: {
    ...mapState(['locale']),
    content() {
      return this.$store.getters.content;
    },
    qr_code_src() {
      return this.qr_code;
    }
  },
  mounted() {
    this.setQrCode();
  }
}
